import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { post } from "../api"

export const appCommonSlice = createSlice({
    name: 'appCommon',
    initialState: {
        //game type list
        loadingGameType: false,
        gameType: null
    },
    reducers: {

    },
    extraReducers: builder => {

    }
})
export const { resetGameTypeResponse } = appCommonSlice.actions

export default appCommonSlice.reducer